module.exports = __webpack_public_path__ + "static/img/icon_yunma.bc465c40.png";